import { computed, MaybeRefOrGetter, toValue } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'

const ContractSummaryFields = graphql(`
  fragment ContractSummaryFields on Contract {
    id
    status
    jobName
    jobDescription
    startDate
    endDate
    rate
    rateType
    currency
    purchaseOrderNumber
    location {
      country {
        name
      }
      formattedAddress
    }
    address
    locationPreference
    companyContact {
      id
      name
      email
      avatar
    }
  }
`)

export const HireCurrentContractFragment = graphql(`
  fragment HireCurrentContract on Hire {
    activeContract {
      ...ContractSummaryFields
    }
    latestContract {
      ...ContractSummaryFields
    }
  }
`)

// The contract a hire currently runs on: the active one, else the latest.
export function useHireContract(
  hire: MaybeRefOrGetter<FragmentType<typeof HireCurrentContractFragment> | null | undefined>,
) {
  return computed(() => {
    const current = useFragment(HireCurrentContractFragment, toValue(hire))
    if (!current) return null

    return useFragment(ContractSummaryFields, current.activeContract ?? current.latestContract)
  })
}
